import { createSelector } from 'reselect';


export function getPractices(state) {
  return state.practices;
}

export function getPracticeById(state, practiceId) {
  return getPractices(state).get(practiceId);
}


//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentPractice = createSelector(
  getPractices,
  practices => practices.get(practices.get('practiceId'))
);
